import { render, staticRenderFns } from "./t3.vue?vue&type=template&id=20aba6f9&"
import script from "./t3.vue?vue&type=script&lang=js&"
export * from "./t3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports